<div class="sticky top-0 z-[9999] w-full bg-amber-400 text-amber-900 print:hidden">
    <div class="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-2 text-sm font-medium">
        <span>Preview Mode — This store is not yet visible to the seller or public.</span>
        <a [href]="adminUrl"
           class="whitespace-nowrap rounded bg-amber-800 px-3 py-1 text-xs font-semibold text-white hover:bg-amber-900">
            Return to Admin
        </a>
    </div>
</div>
